import styled from "styled-components"

export const NormalUserContainer = styled.div`  
    min-height: 300px;
    & .chakra-card{
        padding: 20px;
        margin-bottom: 20px;
    }
    & .ball{
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        font-style: italic;
        color: #22C35E;
    }
    & .date{
        text-align: center;
        font-style: italic;
        font-size: 12px;
        margin-bottom: 15px;
    }
    & .status-categories{
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px;
        padding: 10px;
        background-color: #f7fafc;
        border-radius: 8px;
    }
    & .status-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
    & .status-label{
        font-size: 12px;
        color: #4a5568;
        margin-bottom: 4px;
    }
    & .status-count{
        font-size: 18px;
        font-weight: bold;
        color: #2d3748;
    }
    & .status-item.bajarilganlar .status-count{
        color: #d69e2e; /* Yellow */
    }
    & .status-item.tasdiqlanganlar .status-count{
        color: #38a169; /* Green */
    }
    & .status-item.rad-etilganlar .status-count{
        color: #e53e3e; /* Red */
    }
    & .partition__name{
        margin-right: 12px;
        font-size: 16px;
        font-weight: 500;
    }
    & .error{
        color: red;
    }
    & .user_card{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        @media (max-width: 600px) {
            display: flex;
            flex-direction: column;
        }
    }
    & .user{
            display: flex;
            align-items: center;
            justify-content: center;
            & .user_info{
                padding: 0 10px;
                & .name{
                    font-size: 14px;
                    font-weight: bold;
                }
                & .position{
                    font-size: 10px; 
                }

            }
        }

    & .apps{
        & .head{
            padding-bottom: 10px;
            & h1{
                font-size: 24px;
                font-weight: 500;
            }
        }
        & .loading_target{
            display: flex;
            justify-content: center;
            align-items: center;
        }
        & .app_head{
            padding: 0 0 10px 0;
            @media (max-width: 900px) {
                display: flex;
                flex-direction: column;
            }
            & .app_status{
                padding-right: 20px;
            }
            & .app_ball{ 
                font-size: 24px;
                font-weight: bold;
                font-style: italic;
                color: #22C35E;
                padding-right: 20px;
            }
            & .app_date{
                padding-right: 20px;
                font-style: italic;

            }
        }
        & .param_details{
            background: #f5f8fb;
            border: 1px solid #e5eef7;
            border-radius: 6px;
            padding: 12px;
            margin-bottom: 12px;
            & .param_title{
                font-weight: 600;
                margin-bottom: 6px;
                white-space: pre-wrap;
                overflow: visible;
                text-overflow: initial;
            }
            & .param_meta{
                font-size: 13px;
                color: #0f4871;
                margin-bottom: 8px;
            }
            & .param_block{
                margin-bottom: 8px;
                & .label{
                    font-size: 13px;
                    color: #6b7b8a;
                    margin-bottom: 2px;
                }
                & .content{
                    color: #051630;
                    white-space: pre-wrap;
                    overflow: visible;
                    text-overflow: initial;
                }
            }
        }
        & .work{
            color: #051630;
            margin-top: 6px;
            & .label{
                font-size: 13px;
                color: #6b7b8a;
                margin-bottom: 4px;
            }
            & .files{
                margin-top: 8px;
            }
        }
        & .historys{
            & .history{
                border: 1px solid;
                border-color: inherit;
                margin-top: 10px;
                padding: 10px;
                border-radius: 0.375rem;
                & .history_head{
                    padding: 0;
                    & .history_user{
                        display: inline-flex;  
                    }
                    & .h_ball{
                        font-size: 18px;
                    }
                }
                & .label{
                    padding-left: 5px;
                    font-size: 14px;
                }
                & .check_app{
                    display: flex;
                    & .chakra-select__wrapper{
                        width: 200px;
                        margin-right: 10px;
                    }
                }
                & .check_rector{
                    & .chakra-button{
                        margin-right: 10px;
                        margin-bottom: 10px;
                    }

                }
                & .app_err{
                    color: red;
                    padding-left: 5px;
                    font-size: 14px;
                }
            }
        }
    }
`;